import { AxiosInstance } from 'axios';
import { classToPlain } from 'class-transformer';

import { Conto } from '../models/conto.model';
import { BaseService } from './base.service';

export class ContoService extends BaseService {

	constructor(http: AxiosInstance) {
		super(http);
	}

	search(type: string, term: string): Promise<Conto[]> {
		return this.mapResponse(this.http.post(`/ws/conto/search/${type}`, { term }), Conto);
	}
    
	create(type: string, model: Conto): Promise<Conto> {
		return this.mapResponse(this.http.post(`/ws/conto/create/${type}`, classToPlain(model)), Conto);
	}

}